// Libraries
import React from "react";
import { connect } from "react-redux";

// Local Libraries
import { capitalizeFirstLetter, permissionFinder } from "../../helpers/util";
import phrasebookLoad from "../../i18n";
import { gisRoutes } from "../../routes/routes";
import * as token from "../../helpers/token";
import {
  accountTypesConstants,
  portalFunctionalityConstants,
  permissionTypeConst,
} from "../../constants";

// Redux
import {
  accountActions,
  customerActions,
  orderActions,
  notificationActions,
} from "actions";

// Components
import { InfoBox } from "../../components/SkyFramework/Boxes/InfoBox";
import { InfoCounters } from "../../components/SkyFramework/Boxes/InfoCounters";
import { ContentBox } from "../../components/SkyFramework/Boxes/ContentBox";
import { TableDashboard } from "../../components/SkyFramework/Tables/TableDashboard";

// Constants
const phrasebook = phrasebookLoad();
const ORDER_ON = process.env.REACT_APP_ENABLE_ORDER;
const REPORT_ON = process.env.REACT_APP_ENABLE_REPORTING;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedUser: props.authUser,
      accounts: undefined,
      customers: undefined,
      orders: undefined,
      notifications: undefined,
    };
  }

  componentDidMount() {

    // if pccw
    if (token.loggedAccountType() < 200) {
      if (
        permissionFinder(
          this.props.loggedpermissions.loggedPermissions,
          token.loggedAccountType(),
          portalFunctionalityConstants.account.account,
          permissionTypeConst.LIST,
          token.loggedToken()
        )
      )
        this.props.dispatch(
          accountActions.getAllAccounts(this.state.limit, 0, {
            last_login: true,
            orderby: "last_login",
          })
        );
      this.props.dispatch(customerActions.getAll(0, this.state.page));
      // if customer
    } else {
      if (
        permissionFinder(
          this.props.loggedpermissions.loggedPermissions,
          token.loggedAccountType(),
          portalFunctionalityConstants.account.account,
          permissionTypeConst.LIST,
          token.loggedToken()
        )
      )
        this.props.dispatch(
          accountActions.getAllByCustomer(this.state.limit, 0, {
            last_login: true,
            orderby: "last_login",
          })
        );
    }

    if (
      permissionFinder(
        this.props.loggedpermissions.loggedPermissions,
        token.loggedAccountType(),
        portalFunctionalityConstants.management.order,
        permissionTypeConst.LIST,
        token.loggedToken()
      ) && ORDER_ON == "true"
    )
      this.props.dispatch(orderActions.getAll(this.state.limit, 0));
    this.props.dispatch(
      notificationActions.getAllNew(0, 0, {
        receiver_account_id: this.state.loggedUser.id,
        notification_read: false,
      })
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.accounts &&
      prevProps &&
      prevProps.accounts !== this.props.accounts
    ) {
      this.setState({ accounts: this.props.accounts });
    }
    if (
      this.props.customers &&
      prevProps &&
      prevProps.customers !== this.props.customers
    ) {
      this.setState({ customers: this.props.customers });
    }
    if (
      this.props.orders &&
      prevProps &&
      prevProps.orders !== this.props.orders
    ) {
      this.setState({ orders: this.props.orders });
    }
    if (
      this.props.notifications &&
      prevProps &&
      prevProps.notifications !== this.props.notifications
    ) {
      this.setState({ notifications: this.props.notifications });
    }
  }

  // SystemAdminBoxInfo = () => {

  //   if (this.props.account || this.state.account) {
  //     let account = this.props.account || this.state.account;
  //     let labels = [phrasebook.profile.username,
  //     phrasebook.profile.email,
  //     phrasebook.profile.last_login,
  //     phrasebook.profile.account_type,
  //     phrasebook.profile.customer_name,
  //     phrasebook.references.currency

  //     ]
  //     //, ['Currency', 'currency']
  //     return (<InfoBox
  //       labels={labels}
  //       keys={['username', 'email', 'last_login', ['AccountType', 'account_type'], ['Customer', 'name'], 'currency']}
  //       values={account}
  //     />)
  //   } else return null;
  // }

  // GetCustomerTable = () => {
  //   let labels = [
  //     phrasebook.profile.customer_name,
  //     phrasebook.common.id,
  //     phrasebook.common.website
  //   ];
  //   if (this.state.customers) {
  //     let customers = this.props.customers.customers || this.state.customers;
  //     return (<TableDashboard
  //       labels={labels}
  //       title={capitalizeFirstLetter(phrasebook.headerlinks.customers)}
  //       main_key={'name'}
  //       keys={['name', 'id', 'website']}
  //       values={customers}
  //     />)
  //   } else return null;
  // }
  ContentBox = () => {
    if (token.loggedAccountType() < 200) {
      return (
        <ContentBox
          intro={phrasebook.portal_view.intro}
          text1={phrasebook.portal_view.pccwglobal_intro}
        />
      );
    } else {
      if (
        permissionFinder(
          this.props.loggedpermissions.loggedPermissions,
          token.loggedAccountType(),
          portalFunctionalityConstants.management.order,
          permissionTypeConst.LIST,
          token.loggedToken()
        ) && ORDER_ON == "true"
      )
        return (
          <ContentBox
            // KC- disabling make an order
            info={phrasebook.orders.make_order}
            location={gisRoutes.management.order.list}
            intro={capitalizeFirstLetter(phrasebook.common.welcome)}
            text1={phrasebook.portal_view.make_order}
            // KC-removing below text
            text2={phrasebook.portal_view.select_from_number}
          />
        );
      else
        return (
          <ContentBox
            info={phrasebook.headerlinks.service_coverage}
            location={gisRoutes.management.service_number_coverage.list}
            intro={capitalizeFirstLetter(phrasebook.common.welcome)}
            text1={phrasebook.portal_view.make_order}
          />
        );
    }
  };
  LastLogged = () => {
    if (this.state.accounts) {
      var labels = [
        phrasebook.profile.email,
        // phrasebook.profile.company,
        // phrasebook.profile.firstname,
        // phrasebook.profile.lastname,
        // phrasebook.profile.jobtitle,
        phrasebook.profile.account_type,
        phrasebook.profile.last_login,
      ]
      var fields = ['email',
        // ['customer', 'name'], ['userprofile', 'firstname'], ['userprofile', 'lastname'],
        ['accounttype', 'account_type'], 'last_login']
      return <TableDashboard
        title={'Last Logged Accounts'}
        values={this.state.accounts.data}
        labels={labels}
        keys={fields}
      />;
    } else return null;
  }

  InfoCounters = () => {
    var counters = [];
    // What counters can we have?
    // customers (just pccw)
    // accounts (per customer or total)
    // notifications (new)
    // orders (total)
    if (this.state.customers) {
      counters.push({
        title: phrasebook.headerlinks.customers,
        count: this.state.customers.count,
        info: "Total customers on GIS application",
        location: gisRoutes.account.customer.list,
      });
    }
    if (this.state.accounts) {
      counters.push({
        title: `Active ${phrasebook.headerlinks.accounts}`,
        count: this.state.accounts.count,
        info: "Total accounts on GIS application",
        location: gisRoutes.account.account.list,
      });
    }
    // KC - disable orders and notification from dashboard
    if (this.state.orders && ORDER_ON == "true") {
      counters.push({
        title: phrasebook.headerlinks.orders,
        count: this.state.orders.count,
        info: "Total orders",
        location: gisRoutes.management.order.list,
      });
    }
    if (this.state.notifications) {
      counters.push({
        title: phrasebook.notifications.new_notifications,
        count: this.state.notifications.count,
        info: "New Notifications",
        location: gisRoutes.notification.notification.list,
      });
    }

    if (counters.length > 0) return <InfoCounters counters={counters} />;
    else return null;
  };

  render = () => {
    return (
      <>
        {this.ContentBox()}
        <div className="container pt-0">
          {" "}
          <h3>
            {" "}
            {capitalizeFirstLetter(phrasebook.common.welcome)}{" "}
            {this.state.loggedUser.username}
          </h3>
          <h4>
            {phrasebook.profile.account_type}:{" "}
            {
              phrasebook.accounts[
              accountTypesConstants[this.state.loggedUser.account_type_id]
              ]
            }
          </h4>
          {this.InfoCounters()}

          {this.LastLogged()}

        </div>
      </>
    );
  };
}

function mapStateToProps(state) {
  const {
    loggedpermissions,
    authentication,
    account,
    customer,
    notification,
    order,
  } = state;
  const { authUser } = authentication;
  return {
    loggedpermissions,
    authUser,
    accounts: account.accounts,
    customers: customer.customers,
    orders: order.orders,
    notifications: notification.new_notifications,
  };
}

const dashboard = connect(mapStateToProps)(Dashboard);
export default dashboard;
